import { useEffect } from "react"
import { carrotClient } from "#/utils/CarrotClient"
import { Device } from "@twilio/voice-sdk"

export function useDeviceInitialization(open: boolean, setDevice: (device: Device) => void): void {
  useEffect(() => {
    async function initializeDevice(): Promise<void> {
      if (open) {
        const tokenResponse = await carrotClient.getTwilioToken()
        const newDevice = new Device(tokenResponse.token, { logLevel: 3 })
        setDevice(newDevice)
      }
    }

    if (open) {
      initializeDevice()
    }
  }, [open, setDevice])
}
